import Vue from 'vue';
import VueRx from 'vue-rx';
import VueMask from 'v-mask';
import VTooltip from 'v-tooltip';
import VueLineClamp from 'vue-line-clamp';
import VueInputAutowidth from 'vue-input-autowidth';
import VueWaypoint from 'vue-waypoint';
import PortalVue from 'portal-vue';
import './plugins/axios';
import './globalComponents';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import './filters';
import './directives';
import './utils/polyfills';
import globalMixin from './mixins/global';
import VueWorker from 'vue-worker';

// trackers
import './utils/tracker';
import { isDevelopment } from '@/utils/env';

Vue.use(VueWorker);
Vue.use(VueWaypoint);
Vue.use(PortalVue);

Vue.use(VueRx);
Vue.use(VueLineClamp, {
    importCss: true,
});

Vue.use(VueInputAutowidth);
Vue.use(VueMask);
Vue.use(VTooltip, {
    defaultPlacement: 'bottom',
    defaultClass: 'adriel-tooltip',
    defaultHideOnTargetClick: false,
    popover: {
        defaultPlacement: 'bottom',
        defaultClass: 'adriel-tooltip adriel-tooltip-popover',
        defaultWrapperClass: 'adriel-tooltip-wrapper',
        defaultInnerClass: 'adriel-tooltip-inner',
        defaultTrigger: 'hover',
        defaultContainer: 'body',
    },
});

Vue.config.comma = 188;
Vue.config.productionTip = false;

Vue.mixin(globalMixin);

const appVue = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');

window.app = appVue;

if ('production' !== process.env.NODE_ENV) {
    window.R = R;
}

export { i18n, store, router };

// This is for HMR
if (isDevelopment && module.hot) {
    module.hot.accept?.();
}
